import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { trackSurface } from './platform/analytics';
import './styles.css';
import {registerOffline} from './platform/install';
void registerOffline();

// 진입 즉시 1회. 라우트·상태 뒤로 미루면 랜딩만 보고 떠난 방문자가 빠져
// 퍼널의 분모가 사라진다.
trackSurface('app_open');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><App /></React.StrictMode>,
);

// Keep form controls clear of the software keyboard; no input values leave the device.
window.addEventListener('focusin',event=>{if(event.target instanceof HTMLInputElement||event.target instanceof HTMLTextAreaElement)setTimeout(()=>{(event.target as HTMLElement).scrollIntoView({block:'center',behavior:'smooth'});},150);});
const keyboard=()=>document.body.classList.toggle('keyboard-open',Boolean(window.visualViewport&&window.visualViewport.height<window.innerHeight*.7));
window.visualViewport?.addEventListener('resize',keyboard);
